export default class FormValidator {
    static fieldEmpty (string) {
        return !string.length
    }
}